import styled from "styled-components";
import { Typography } from "antd";

const { Title } = Typography;

export const TitleH5 = styled(Title).attrs({
  level: 5,
})``;
